import React, { useState, Fragment } from 'react'
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types'

import './features24.css'

const Features24 = ({
  feature1Title = undefined,
  feature1ImgAlt = undefined,
  feature1Description = undefined,
  feature1ImgSrc = undefined,
  feature2Title = undefined,
  feature2ImgAlt = undefined,
  feature2Description = undefined,
  feature2ImgSrc = undefined,
  feature3Title = undefined,
  feature3ImgAlt = undefined,
  feature3Description = undefined,
  feature3ImgSrc = undefined
}) => {

  const [activeTab, setActiveTab] = useState(0)
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'es' ? 'es' : 'en';

  return (
    <div className="thq-section-padding">
      <div className="features24-container2 thq-section-max-width">
        <div className="features24-image-container">
          {activeTab === 0 && (
            <img
              alt={feature1ImgAlt ?? t('features.whatsappChatbot.title')}
              src={feature1ImgSrc ?? `images/features/chatbot-${lang}.jpg`}
              className="features24-image1 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 1 && (
            <img
              alt={feature2ImgAlt ?? t('features.digitalCatalog.title')}
              src={feature2ImgSrc ?? `images/features/catalog-${lang}.jpg`}
              className="features24-image2 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 2 && (
            <img
              alt={feature3ImgAlt ?? t('features.onlineOrders.title')}
              src={feature3ImgSrc ?? `images/features/online-orders-${lang}.jpg`}
              className="features24-image3 thq-img-ratio-16-9"
            />
          )}
        </div>
        <div className="features24-tabs-menu">
          <div
            onClick={() => setActiveTab(0)}
            className="features24-tab-horizontal1"
          >
            <div className="features24-divider-container1">
              {activeTab === 0 && <div className="features24-container3"></div>}
            </div>
            <div className="features24-content1">
              <h2 className="thq-heading-2">
                {feature1Title ?? (
                  <Fragment>
                    <span className="features24-text4">
                      {t('features.whatsappChatbot.title')}
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {feature1Description ?? (
                  <Fragment>
                    <span className="features24-text5">
                      {t('features.whatsappChatbot.description')}
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            className="features24-tab-horizontal2"
          >
            <div className="features24-divider-container2">
              {activeTab === 1 && <div className="features24-container4"></div>}
            </div>
            <div className="features24-content2">
              <h2 className="thq-heading-2">
                {feature2Title ?? (
                  <Fragment>
                    <span className="features24-text6">
                      {t('features.digitalCatalog.title')}
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {feature2Description ?? (
                  <Fragment>
                    <span className="features24-text3">
                      {t('features.digitalCatalog.description')}
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            className="features24-tab-horizontal3"
          >
            <div className="features24-divider-container3">
              {activeTab === 2 && <div className="features24-container5"></div>}
            </div>
            <div className="features24-content3">
              <h2 className="thq-heading-2">
                {feature3Title ?? (
                  <Fragment>
                    <span className="features24-text2">
                      {t('features.onlineOrders.title')}
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {feature3Description ?? (
                  <Fragment>
                    <span className="features24-text1">
                      {t('features.onlineOrders.description')}
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features24.propTypes = {
  feature1Title: PropTypes.element,
  feature1ImgAlt: PropTypes.string,
  feature1Description: PropTypes.element,
  feature1ImgSrc: PropTypes.string,
  feature2Title: PropTypes.element,
  feature2ImgAlt: PropTypes.string,
  feature2Description: PropTypes.element,
  feature2ImgSrc: PropTypes.string,
  feature3Title: PropTypes.element,
  feature3ImgAlt: PropTypes.string,
  feature3Description: PropTypes.element,
  feature3ImgSrc: PropTypes.string,
}

export default Features24
